<template>
  <div>
    <highcharts :options="chartOptions" />
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import moment from 'moment'

export default {
  name: 'ColumnsHistory',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    dateFormat () {
      return {
        day: {
          tickInterval: 24 * 3600 * 1000,
          // format: '%e. %b',
          moment: 'D. MMM',
          d: 'dayMonth'
        },
        month: {
          tickInterval: 30 * 24 * 3600 * 1000,
          // format: '%b \'%y',
          moment: 'MMM \'YY',
          d: 'monthYear'
        },
        year: {
          tickInterval: 12 * 30 * 24 * 3600 * 1000,
          // format: '%Y',
          moment: 'YYYY',
          d: 'year'
        }
      }[this.dataChart.group_range]
    },
    chartOptions () {
      const _self = this
      return {
        // time: {
          // timezone: 'Europe/Paris'
        // },
        chart: {
          type: 'column',
          height: 320,
          // scrollablePlotArea: {
          //   minWidth: this.dataChart.series.length * 10 // 400
          // },
          events: {
            click: function (event) {
              const point = this.series[0].searchPoint(event, true)
              _self.expand(point.options.filters, point.category)
            }
          },
          style: {
            cursor: 'pointer'
          }
        },
        title: {
          text: null
        },
        legend: {
          enabled: false
        },
        xAxis: {
          crosshair: true,
          type: 'datetime',
          tickInterval: this.dateFormat.tickInterval,
          labels: {
            // format: `{value:${this.dateFormat.format}}`
            formatter: (val) => {
              // const date = moment.tz(val.value, null, 'UTC').toDate()
              return _self.foramtDate(val.value)
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          title: {
            text: this.dataChart.metric_name
          },
          min: 0
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (a) => {
                  // const date = moment.tz(a.point.category, null, 'UTC').toDate()
                  this.expand(a.point.options.filters, a.point.category)
                }
              }
            }
          }
        },
        tooltip: {
          shared: true,
          formatter: function () {
            // const date = moment.tz(this.x, null, 'UTC').toDate()
            return `
              <b>${_self.foramtDate(this.x)}:</b><br>
              ${_self.dataChart.metric_name}: ${this.y} ${_self.valueType}
            `
          }
          // headerFormat: `<b>{point.key}</b><br>`,
          // pointFormat: `{series.name}: {point.y}${this.valueType}`
        },
        series: [{
          name: this.dataChart.metric_name,
          data: this.dataChart.series
          /* data: [
            [Date.UTC(1970, 9, 31), 0.09],
            [Date.UTC(1970, 10,  7), 0.17],
            [Date.UTC(1970, 10, 10), 0.1],
            [Date.UTC(1970, 11, 10), 0.1],
            [Date.UTC(1970, 11, 13), 0.1],
            [Date.UTC(1970, 11, 16), 0.11],
            [Date.UTC(1970, 11, 19), 0.11],
            [Date.UTC(1970, 11, 22), 0.08],
            [Date.UTC(1970, 11, 25), 0.23],
            [Date.UTC(1970, 11, 28), 0.37]
          ] */
        }]
      }
    }
  },
  created () {
  },
  methods: {
    foramtDate (timeUnix) {
      const secDiff = moment().zone() * 100000
      const date = moment.utc(timeUnix + secDiff).toDate()
      return this.$d(date, this.dateFormat.d)
    },
    expand (filters, timeUnix) {
      this.$emit('expand', {
        filters: filters,
        name: this.foramtDate(timeUnix)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/ColumnsHistory.vue